export default __webpack_public_path__ + "static/media/linkedin.8d36eeb9.svg";